module.exports = __webpack_public_path__ + "img/wxCode.fab39237.png";